// extracted by mini-css-extract-plugin
export default {"container":"Chips-module__container--JJGLL","chips":"Chips-module__chips--M4O3v"};